import './InviteModal.scss';
import { AsyncStateNotification } from '@ui/notifications';
import { Button } from 'antd';
import { createAsyncSelectors } from '@lib/selectors';
import { securityActions } from '@sonar-software/sonar-security';
import { SonarModal } from '@ui/modals';
import { COPY_GENERIC, COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { CopyText, SonarText } from '@ui/text';
import React, { useCallback, useEffect } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const inviteUserByIdSelectors = createAsyncSelectors((state) => state.security.invitations.resend.post);
export const InviteModal = ({ afterClose, inviteLink, onCancel, user, open }) => {
    const isResendRequesting = useSonarSelector(inviteUserByIdSelectors.isRequested);
    const isResendSuccessful = useSonarSelector(inviteUserByIdSelectors.isReceived);
    const requestResendInvite = useAction(securityActions.requestPostSecurityInvitationsResend);
    const handleResendEmail = useCallback(() => {
        requestResendInvite({
            userId: user.id
        });
    }, [requestResendInvite, user.id]);
    useEffect(() => {
        if (isResendSuccessful) {
            onCancel();
        }
    }, [isResendSuccessful, onCancel]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SonarModal, { afterClose: afterClose, centered: true, className: 'invite-modal', footer: React.createElement(Button, { key: 'submit', loading: isResendRequesting, onClick: handleResendEmail, type: 'primary' }, COPY_SPECIFIC.RESEND_EMAIL), onCancel: onCancel, open: open, title: COPY_SPECIFIC.USER_INVITATION_OPTIONS },
            React.createElement(SonarText, { className: 'sub-text' }, COPY_GENERIC.INVITE_SUBTEXT(user.email)),
            React.createElement(CopyText, { className: 'invite-link', text: inviteLink })),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_POST_USER_INVITE, failed: NOTIFICATIONS_COPY.FAILED_POST_USER_INVITE, received: NOTIFICATIONS_COPY.SUCCESS_POST_USER_INVITE, resetRawAction: securityActions.resetPostSecurityInvitationsResend, stateSelector: inviteUserByIdSelectors.state })));
};
